export type P1FormData = {
    subject_matter: string;
    delimitation: {
        temporal: string;
        spatial: string;
        institutional: string;
        functional: string;
    };
    criteria: { code: string; source: string; standards: string; type: string }[];
    evidence_strategy: { type: string; sources: string; technique: string }[];
    audit_problem: string;
    problem_bullets: string[];
    stakeholders: {
        name: string;
        interest: string;
        influence: "high" | "low";
        interest_level: "high" | "low";
        relevance: string;
    }[];
    assurance_level: "reasonable" | "limited";
    assurance_justification: string;
    objective: string;
    smart_checks: { criterion: string; met: boolean; basis: string }[];
    out_of_scope: string[];
    scope: { dimension: string; delimitation: string }[];
    engagement_risks: {
        code: string;
        risk: string;
        impact: string;
        probability: string;
        level: string;
        response: string;
    }[];
    deliverables_tracker: {
        phase: string;
        stage: string;
        deliverable: string;
        status: string;
    }[];
    timeline: { milestone: string; target: string }[];
    benefits_financial: { description: string; value: string }[];
    benefits_non_financial: { description: string; value: string }[];
    process_flow: string[];
};

export function defaultP1FormData(): P1FormData {
    return {
        subject_matter: "",
        delimitation: {
            temporal: "",
            spatial: "",
            institutional: "",
            functional: "",
        },
        criteria: [],
        evidence_strategy: [],
        audit_problem: "",
        problem_bullets: [],
        stakeholders: [],
        assurance_level: "reasonable",
        assurance_justification: "",
        objective: "",
        smart_checks: [
            { criterion: "Specific", met: false, basis: "" },
            { criterion: "Measurable", met: false, basis: "" },
            { criterion: "Achievable", met: false, basis: "" },
            { criterion: "Relevant", met: false, basis: "" },
            { criterion: "Time-bound", met: false, basis: "" },
        ],
        out_of_scope: [],
        scope: [],
        engagement_risks: [],
        deliverables_tracker: [],
        timeline: [],
        benefits_financial: [],
        benefits_non_financial: [],
        process_flow: [],
    };
}
